import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import logo from '../../assets/img/horn.png';
import { subscribeEmail } from '../../services/contact.service';
import { useToast } from '../../context/ToastContext';
import { useSiteSettings } from '../../hooks/useSiteSettings';
import { getSocialLinks } from '../../services/settings.service';

const Footer = () => {
  const { notify } = useToast();
  const { settings } = useSiteSettings();
  const socialLinks = getSocialLinks(settings);
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      notify('Please enter your email.', { type: 'error' });
      return;
    }
    setSubmitting(true);
    try {
      await subscribeEmail(email.trim());
      notify('Subscribed successfully.', { type: 'success' });
      setEmail('');
    } catch (err) {
      notify(err?.message || 'Failed to subscribe.', { type: 'error' });
    } finally {
      setSubmitting(false);
    }
  };

  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (_) {
      // fallback
      window.scrollTo(0, 0);
    }
  };
  return (

    <>
      {/* footer part */}
      <footer className="site-footer" id="colophon">
        <div className="top-footer">
          <div className="footer-overlay" />
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <aside className="widget widget_text img-textwidget">
                  <div className="footer-logo">
                    <Link to="/" onClick={scrollToTop}>
                      <img alt="Horn Petroleum logo" src={logo} />
                    </Link>
                  </div>
                  <div className="textwidget widget-text">
                    Horn Petroleum is the biggest company in the market for
                    petroleum products in Somaliland and Somalia.
                  </div>
                  <ul className="footer-contact-info">
                    <li>
                      <a href={`tel:${settings.phone1}`}>
                        <i aria-hidden="true" className="icon icon-phone1" />
                        {settings.phone1}
                      </a>
                    </li>
                    <li>
                      <a href={`mailto:${settings.email1}`}>
                        <i aria-hidden="true" className="icon icon-envelope3" />
                        {settings.email1}
                      </a>
                    </li>
                  </ul>
                </aside>
                <div className="footer-social-links">
                  <ul>
                    {socialLinks.map(item => (
                      <li key={item.key}>
                        <a href={item.url} target="_blank" rel="noreferrer" aria-label={item.label}>
                          {item.iconText ? (
                            <span aria-hidden="true" className="social-letter-icon">{item.iconText}</span>
                          ) : (
                            <i aria-hidden="true" className={item.icon} />
                          )}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <aside className="widget">
                  <h5 className="title-divider-right">Our Services</h5>
                  <ul>
                    <li>
                      <Link to="/carwash" onClick={scrollToTop}>Car Wash</Link>
                    </li>
                    <li>
                      <Link to="/contact" onClick={scrollToTop}>24/7 Support</Link>
                    </li>
                    <li>
                      <Link to="/locations" onClick={scrollToTop}>Fuel Stations</Link>

                    </li>
                    <li>
                      <Link to="/contact" onClick={scrollToTop}>Gas Delivery</Link>


                    </li>
                    {/* <li>
                <a href="service-detail.html">Building Services</a>
              </li> */}
                  </ul>
                </aside>
              </div>
              <div className="col-lg-3 col-md-6">
                <aside className="widget">
                  <h5 className="title-divider-right">Useful Links</h5>
                  <ul>
                    <li>
                      <Link to="/" onClick={scrollToTop}>Home Page</Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={scrollToTop}>About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact" onClick={scrollToTop}>Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/terms" onClick={scrollToTop}>Terms and Conditions</Link>
                    </li>
                    <li>
                      <Link to="/privacy" onClick={scrollToTop}>Privacy Policy</Link>
                    </li>
                  </ul>
                </aside>
              </div>
              <div className="col-lg-3 col-md-6">
                <aside className="widget widget_text">
                  <h5 className="title-divider-right">Newsletter Sign Up</h5>
                  <div className="textwidget widget-text">
                    Sign Up To Get Exclusive Offers And News From Our Favorite
                    Brands !
                  </div>
                  <form className="footer-form" onSubmit={onSubscribe}>
                    <div className="form-group">
                      <input
                        name="email"
                        placeholder="Your email address.."
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <button className="button-round-gradient" type="submit" disabled={submitting}>
                      {submitting ? 'SUBSCRIBING...' : 'SUBSCRIBE NOW'}
                    </button>
                  </form>
                </aside>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-footer">
          <div className="copy-right text-center">
            Copyright © 2026 Horn Petroleum. All rights reserved.
          </div>
        </div>
      </footer>
      {/* back to top */}
      <button
        type="button"
        className="to-top-icon"
        id="backTotop"
        aria-label="Back to top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        <i className="fas fa-chevron-up" />
      </button>
      {/* custom search field html */}
      <div className="header-search-form">
        <div className="container">
          <div className="header-search-container">
            <form className="search-form" method="get" role="search">
              <input name="search" placeholder="Enter your text..." type="text" />
            </form>
            {/* Container for displaying matched items */}
            <ul id="result-list" />
            <button type="button" className="search-close" aria-label="Close search">
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
      </div>
    </>

  );
};

export default Footer;
